import React, { useContext, useState } from 'react';

//components
import FixedPositionContextMenu from '../global/lists/FixedPositionContextMenu/FixedPositionContextMenu';
import CaretButton from '../global/buttons/CaretButton';
import LinkStyleButton from '../global/buttons/LinkStyleButton';
import Icon from '../icons/Icons';

//interfaces
import { IconLibrary } from  '@/interfaces/IconLibrary';
import { IAssignRoleControl } from  '@/interfaces/ContentAudienceModal';
import Loading from '../global/LoadingDots';
import { ContentAudienceContext } from './ContentAudienceContext';
import { isOrganisationAdmin } from  '@/helpers/OrgSettings';
import { ResourcePermission } from  '@/interfaces/orgSettings';
import { IGroups } from  '@/interfaces/api/ContentAudience';

const AssignRoleControl = ({userOrGroup, addToRecentlyAdded, removeRecentlyAdded}: IAssignRoleControl) => {
    const [controlIsOpen, setControlIsOpen] = useState<boolean>(false);

    const isAdminOrWorkspaceEditor = isOrganisationAdmin(userOrGroup?.permission, userOrGroup?.grantType)
    const { updatingUserOrGroupIds } = useContext(ContentAudienceContext);

    function isLoading(){
        return updatingUserOrGroupIds.includes(userOrGroup.id)
    }

    if(isLoading()) {
        return <Loading />
    }

    return (
        
        userOrGroup.isRecentlyAdded
            ?   <LinkStyleButton className='undo-buton-link-button' onButtonClick={() => removeRecentlyAdded(userOrGroup)} ariaLabel={`undo selection for  ${(userOrGroup as IGroups)?.name}`}
                    content={<span className='undo-button-wrapper'><Icon iconName={IconLibrary.CHECK} sizeInPx='12' color='green' /> <span className='undo-button-text'>Undo</span></span>}
                />
            :   <FixedPositionContextMenu 
                    controlIsOpen={controlIsOpen}
                    setControlIsOpen={setControlIsOpen}
                    anchorButton={<CaretButton content={'Select a role...'} ariaLabel={`select a role for ${(userOrGroup as IGroups)?.name}`} onButtonClick={() => setControlIsOpen(true)} isDisabled={isAdminOrWorkspaceEditor} />}
                    menuButtons={[
                        {content: <span>Add as a Viewer</span>, onClick:() => addToRecentlyAdded({...userOrGroup, isRecentlyAdded: true}, ResourcePermission.READ)}, 
                        {content: <span>Add as an Editor</span>, onClick:() => addToRecentlyAdded({...userOrGroup, isRecentlyAdded: true}, ResourcePermission.MANAGE)}]}
                    closeOnScrollTarget='.simplebar-content-wrapper'
                    containerQuerySelector='.ReactModal__Content'
                    manualOffset={{top: 5, right: 30}}
                />
    )
}

export default AssignRoleControl